export default __webpack_public_path__ + "static/media/edge_icon.242dad54.png";